<!--
 * @Author: your name
 * @Date: 2021-06-25 11:23:51
 * @LastEditTime: 2021-12-18 18:17:36
-->
<template>
    <div class="activation" v-show="activationVisible">
        <el-dialog title :visible.sync="activationVisible" :show-close="false" width="760px" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="activation-title">
                <img src="../../assets/images/activation-txt.png" alt="账户激活" />
            </div>
            <div class="activation-desc">
                尊敬的客户，我是您的站神小助理，感谢您选择站神平台。站神是一款自助型的建站工具，我们可以通过在线听课学习以及观看视频学习来快速掌握建站技巧。 现在我们开始进行站神的自学。
                <br />在开通站神账户后，
                <b>15天内完成观看学习视频，单仁牛商会赠送1个月站神使用期限（即13个月）</b>。
                <br />注：首套站神使用期限从完成观看视频，且点击确认即开始计算。完成观看学习视频后即可开始制作网站。
            </div>
            <el-button type="primary" @click="useractivation">{{activationBtn}}</el-button>
        </el-dialog>
    </div>
</template>

<script>
import userApi from '@/api/user.api'
export default {
    name: 'accountActivation',
    data () {
        return {
            isActivationShow: false,
            activationVisible: false,
            isBulletBox: false,
            activationBtn: '我已知悉，开始观看学习视频'
        }
    },
    created () {
    },
    watch: {
        isBulletBox: {
            handler (newVal, oldVal) {
                this.isBulletBox ? this.userConfig() : ''
            }
        }
    },
    methods: {
        async userConfig () {
            let { data } = await userApi.getConfig()

            if (data.isSuccess) {
                //判断是否付费,是否为线下订单,是否有激活时间,是否为半定制项目
                if (data.data.isVip != '1' || (data.data.lineStatus === '1' && data.data.activationTime) || data.data.customized === '1') {
                    sessionStorage.setItem('isActivationShow', 'false')
                    sessionStorage.setItem('isLearn', 'true')
                    this.activationVisible = false
                    return
                }
                if (data.data.avgVideo < 100) {
                    data.data.activationTime.length > 0 ? this.activationBtn = `您已经学习${data.data.avgVideo}%，完成学习即可开始制作网站` : ''
                    this.isActivationShow = (sessionStorage.getItem('isActivationShow') === 'false') ? false : true
                    sessionStorage.setItem('isLearn', 'false')
                    if (this.isActivationShow || this.isBulletBox) this.activationVisible = true
                    //判断之前的看完视频和下线交互的自动激活
                } else if ((data.data.avgVideo === 100 || data.data.lineStatus === '1') && !data.data.activationTime) {
                    this.useractivation(true)
                    sessionStorage.setItem('isLearn', 'true')
                }
            } else {
                sessionStorage.setItem('isActivationShow', 'false')
                sessionStorage.setItem('isLearn', 'true')
                this.activationVisible = false
            }
            this.isBulletBox = false
        },
        async useractivation (type) {
            let { data } = await userApi.getActive()
            if (data.isSuccess) {
                this.activationVisible = false
                sessionStorage.setItem('isActivationShow', 'false')
                if (type === true) return
                window.open(window.location.href.split('#')[0] + '#/course/userCourse', '_blank')
                // window.location.href = window.location.href.split('#')[0] + '#/course/userCourse'

            } else {
                console.log(data.message, '用户激活')
            }
        }
    },
}
</script>
<style lang='scss' scoped>
.activation-title {
    margin-bottom: 6px;
}
.activation-desc {
    font-size: 17px;
    line-height: 34px;
    letter-spacing: 0.9px;
    color: #e2e2e2;

    b {
        color: #fff;
    }
}
</style>
